import { ApiResponse } from "@/features/airtable/types/ApiResponse";
import { ItemPayload } from "@/features/airtable/types/ItemPayload";
import { BASE_URL, requestOptionsGET } from "../Constants";

export async function getAirtableItem(
    idToken: string,
    itemId: number,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/${itemId}`, requestOptionsGET(idToken))
        const data = await response.json();
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }
        return { success: true, data };
    } catch (error) {
        console.error("getItem error:", error);
        return { success: false, error: "Errore imprevisto dal server" };
    }
}

export async function createItem(
    idToken: string,
    item: ItemPayload,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify(item),
        });

        const data = await response.json();
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }
        return { success: true, data };
    } catch (error) {
        console.error("createItem error:", error);
        return { success: false, error: "Errore imprevisto durante la creazione" };
    }
}

export async function createAirtableRecord(
    idToken: string,
    fields: Record<string, any>,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify({ fields }),
        });

        const data = await response.json();
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }
        return { success: true, data };
    } catch (error) {
        console.error("createAirtableRecord error:", error);
        return { success: false, error: "Errore imprevisto durante la creazione" };
    }
}

export async function updateItem(
    idToken: string,
    itemId: number,
    item: ItemPayload,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/${itemId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify(item),
        });

        const data = await response.json();
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }
        return { success: true, data };
    } catch (error) {
        console.error("updateItem error:", error);
        return { success: false, error: "Errore imprevisto durante l'aggiornamento" };
    }
}

// Fetch all records from Airtable
export async function getAllAirtableRecords(
    idToken: string,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/records`, requestOptionsGET(idToken));
        const data = await response.json();
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }
        return { success: true, data: data.records };
    } catch (error) {
        console.error("getAllAirtableRecords error:", error);
        return { success: false, error: "Errore imprevisto durante il recupero dei record" };
    }
}

export async function getRecordBySortingId(
    idToken: string,
    sorting_id: string,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/sorting-lookup/${sorting_id}`, requestOptionsGET(idToken));
        const data = await response.json();
        
        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }

        return { success: true, data: data.record };
    } catch (error) {
        console.error("getRecordBySortingId error:", error);
        return { success: false, error: "Errore imprevisto durante il recupero del record" };
    }
}

export async function patchRecordBySortingId(
    idToken: string,
    sorting_id: string,
    fields: Record<string, any>,
): Promise<ApiResponse<any>> {
    try {
        const response = await fetch(`${BASE_URL}/api/airtable/update-by-sorting-id/${sorting_id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify({ fields }),
        });

        const data = await response.json();

        if (!response.ok) {
            return { success: false, error: data.detail || "Errore generico" };
        }

        return { success: true, data };
    } catch (error) {
        console.error("patchRecordBySortingId error:", error);
        return { success: false, error: "Errore imprevisto durante l'aggiornamento del record" };
    }
}
